/* template */
<template minapp="mpx" xlang="wxml"><mpx-button hover-class="es-button--active hover-class" :form-type="(formType)" :open-type="(!disabled && openType)" :session-from="(sessionFrom)" :send-message-title="(sendMessageTitle)" :send-message-path="(sendMessagePath)" :send-message-img="(sendMessageImg)" :app-parameter="(appParameter)" :show-message-card="(showMessageCard)" @tap="bindNativeEvent('click', $event)" @getuserinfo="bindNativeEvent('getuserinfo', $event)" @contact="bindNativeEvent('contact', $event)" @getphonenumber="bindNativeEvent('getphonenumber', $event)" @error="bindNativeEvent('error', $event)" @opensetting="bindNativeEvent('opensetting', $event)" @launchapp="bindNativeEvent('launchapp', $event)" class="es-button" :class='[$attrs["custom-class"],(className)]'><div class="es-button__body"><div class="es-button__text"><slot></slot></div></div></mpx-button></template>

/* styles */
<style lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"mbc68cb48"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mbc68cb48"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexbc68cb48%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexbc68cb48%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mbc68cb48"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexbc68cb48/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-button':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
